'use strict';
/**
 * @author Maxim Seredkin
 */
export default['$rootScope', '$scope',
    function ($rootScope, $scope) {

        $scope.setFilter = setFilter;
        $scope.selectAll = selectAll;

        init();

        // region Functions

        function init() {
            $rootScope.title = "Категории земельных участков";

            $scope.filter = {
                enabled: false,
                deleted: false,
            };

            update();
        }

        function update() {
            $scope.filters = [];
            if ($scope.filter.enabled) {
                $scope.filters.push("'status' EQ 'ENABLED'");
            }
            if ($scope.filter.deleted) {
                $scope.filters.push("'status' EQ 'DELETED'");
            }
        }

        function setFilter() {
            update();
        }

        function selectAll() {
            $scope.filter.enabled = true;
            $scope.filter.deleted = true;
            update();
        }

        // endregion

    }];